import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderCardContent';
import { getCurrentUserId } from '../../../publicSession/selectors';

export type StateProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, ownProps) => ({
  isCurrentUserOwner:
    ownProps.folder.owner && getCurrentUserId(state) === ownProps.folder.owner.userId,
});

export default connect(mapStateToProps);
